import { groupBy } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { URL } from "../../../../utils/Constants";

const AdmitCardTemplate3 = (props) => {
  const [filteredTable, setFilteredTable] = useState(null);
  const [filtereduniqueDates, setFilteredUniqueDates] = useState(null);
  const [routineData, setRoutineData] = useState(null);

  useEffect(() => {
    if (props.student !== undefined) {
      transformstudentData(props?.student?.subjects);
      setRoutineData(props?.student?.subjects);
    }
  }, [props.student]);

  const transformstudentData = (data) => {
    const uniqueDates = Array.from(
      new Set(
        data.flatMap((d) => [
          d?.assessmentTheoryFromDate &&
            moment(d.assessmentTheoryFromDate).format("YYYY-MM-DD"),
          d?.assessmentPracticalFromDate &&
            moment(d.assessmentPracticalFromDate).format("YYYY-MM-DD"),
        ]),
      ),
    )
      .filter((item) => !!item)
      .sort();

    const groupedByDateTheory = groupBy(data, (entry) =>
      moment(entry.assessmentTheoryFromDate).format("YYYY-MM-DD"),
    );
    const groupedByDatePractical = groupBy(data, (entry) =>
      moment(entry.assessmentPracticalFromDate).format("YYYY-MM-DD"),
    );

    const mappedSubjects = Object.entries(groupedByDateTheory)
      .concat(Object.entries(groupedByDatePractical))
      .map(([date, entries]) => {
        const datePart = date.split(" ")[0];
        return entries.map((entry) => {
          let theoryDate;
          let practicalDate;
          if (entry?.assessmentTheoryFromDate) {
            theoryDate =
              moment(entry?.assessmentTheoryFromDate).format("YYYY-MM-DD") ===
              datePart;
          }
          if (entry?.assessmentPracticalFromDate) {
            practicalDate =
              moment(entry?.assessmentPracticalFromDate).format(
                "YYYY-MM-DD",
              ) === datePart;
          }
          let time = "";
          let subjectType = "";
          if (theoryDate) {
            time = `Th-${moment(entry.assessmentTheoryFromDate).format(
              "hh:mm A",
            )} to ${moment(entry.assessmentTheoryToDate).format("hh:mm A")}`;
            subjectType = "Th";
          }
          if (practicalDate) {
            if (time) {
              time += ` & Pr-${moment(entry.assessmentPracticalFromDate).format(
                "hh:mm A",
              )} to ${moment(entry.assessmentPracticalToDate).format(
                "hh:mm A",
              )}`;
              subjectType = "Th & Pr";
            } else {
              time = `Pr-${moment(entry.assessmentPracticalFromDate).format(
                "hh:mm A",
              )} to ${moment(entry.assessmentPracticalToDate).format(
                "hh:mm A",
              )}`;
              subjectType = "Pr";
            }
          }
          return {
            subject: entry.name,
            date: datePart,
            time: time,
            subjectType: subjectType,
          };
        });
      });

    const newTable = mappedSubjects.flat().reduce((acc, curr) => {
      if (!acc[curr.date]) {
        acc[curr.date] = [];
      }
      if (curr.time !== "") {
        const existingSubject = acc[curr.date].find((subject) =>
          subject.startsWith(curr.subject),
        );
        if (!existingSubject) {
          acc[curr.date].push(`${curr.subject} (${curr.subjectType})`);
        }
      }
      return acc;
    }, {});

    setFilteredTable(newTable);
    setFilteredUniqueDates(uniqueDates);
    return { table: newTable, uniqueDates };
  };

  return (
    <div style={{ padding: "16px" }} className="admitCardContainer">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          gap: "12px",
          marginBottom: "14px",
          position: "relative",
        }}
      >
        {/* Logo */}
        {props?.schoolInfos?.imageName && (
          <img
            src={`${URL.imageSelectURL}${props?.schoolInfos?.imageName}`}
            alt="School Logo"
            style={{
              width: "22mm",
              height: "22mm",
              objectFit: "contain",
              borderRadius: "4px",
              flexShrink: 0,
              position: "absolute",
              top: 0,
              left: 0,
            }}
          />
        )}

        {/* School Info */}
        <div style={{ textAlign: "center", width: "95mm" }}>
          <div
            style={{ fontSize: "16.5px", fontWeight: "bold", lineHeight: 1.25 }}
          >
            {props?.schoolInfos?.name}
          </div>
          <div style={{ fontSize: "12px", marginTop: "2px" }}>
            {props?.schoolInfos?.address}
          </div>
          <div
            style={{ fontSize: "12.5px", marginTop: "3px", fontWeight: 500 }}
          >
            {props?.assessmentSubjectValue?.assessmentName}
          </div>

          {/* Title Badge */}
          <div style={{ marginTop: "7px" }}>
            <span
              style={{
                display: "inline-block",
                border: "1.5px solid #000",
                borderRadius: "7px",
                padding: "3px 18px",
                fontSize: "13px",
                fontWeight: "bold",
              }}
            >
              Student Admit Card
            </span>
          </div>
        </div>
      </div>

      {/* Student Details Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "11px 22px",
          fontSize: "13.5px", // increased
          marginTop: "18px",
        }}
      >
        {/* Student's Name */}
        <div style={{ display: "flex", alignItems: "baseline", gap: "6px" }}>
          <b style={{ whiteSpace: "nowrap" }}>Student's Name :</b>
          <span
            style={{
              flex: 1,
              borderBottom: "1px dashed #333",
              paddingBottom: "1px",
              minHeight: "19px",
            }}
          >
            {props?.student?.people?.name || ""}
          </span>
        </div>

        {/* Programme */}
        <div style={{ display: "flex", alignItems: "baseline", gap: "6px" }}>
          <b style={{ whiteSpace: "nowrap" }}>Programme :</b>
          <span
            style={{
              flex: 1,
              borderBottom: "1px dashed #333",
              paddingBottom: "1px",
              minHeight: "19px",
            }}
          >
            {props?.classValue?.name || ""}
          </span>
        </div>

        {/* Class */}
        <div style={{ display: "flex", alignItems: "baseline", gap: "6px" }}>
          <b style={{ whiteSpace: "nowrap" }}>Class :</b>
          <span
            style={{
              flex: 1,
              borderBottom: "1px dashed #333",
              paddingBottom: "1px",
              minHeight: "19px",
            }}
          >
            {props?.student?.yearLevel?.name || ""}
          </span>
        </div>

        {/* Section */}
        <div style={{ display: "flex", alignItems: "baseline", gap: "6px" }}>
          <b style={{ whiteSpace: "nowrap" }}>Section :</b>
          <span
            style={{
              flex: 1,
              borderBottom: "1px dashed #333",
              paddingBottom: "1px",
              minHeight: "19px",
            }}
          >
            {props?.student?.classRoom?.name || ""}
          </span>
        </div>

        {/* Roll No */}
        <div style={{ display: "flex", alignItems: "baseline", gap: "6px" }}>
          <b style={{ whiteSpace: "nowrap" }}>Roll No :</b>
          <span
            style={{
              flex: 1,
              borderBottom: "1px dashed #333",
              paddingBottom: "1px",
              minHeight: "19px",
            }}
          />
        </div>

        {/* Hall No */}
        <div style={{ display: "flex", alignItems: "baseline", gap: "6px" }}>
          <b style={{ whiteSpace: "nowrap" }}>Hall No :</b>
          <span
            style={{
              flex: 1,
              borderBottom: "1px dashed #333",
              paddingBottom: "1px",
              minHeight: "19px",
            }}
          />
        </div>
      </div>

      {/* Footer - Date & Principal */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "20px",
          marginTop: "30px",
          fontSize: "13.5px", // increased
        }}
      >
        <div style={{ display: "flex", alignItems: "baseline", gap: "6px" }}>
          <b>Date :</b>
          <span
            style={{
              flex: 1,
              borderBottom: "1px dashed #333",
              paddingBottom: "1px",
              minHeight: "19px",
            }}
          />
        </div>

        <div style={{ display: "flex", alignItems: "baseline", gap: "6px" }}>
          <b>Principal :</b>
          <span
            style={{
              flex: 1,
              borderBottom: "1px dashed #333",
              paddingBottom: "1px",
              minHeight: "19px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AdmitCardTemplate3;
